module.exports = __webpack_public_path__ + "img/symbol_10.9288b4ab.png";